import { CDElement } from "./CDElement";

export class CDText extends CDElement 
{
  private _textContent:string;
  private _isHTML:boolean;

  constructor( textContent:string, isHTML:boolean = false) 
  {
    super( CDElement.CDTextType );
    this._textContent = "";
    this._textContent = textContent;
    this._isHTML = isHTML;
  }

  get textContent()
  {    
    return this._textContent;
  }

  get isHTML()
  {
    return this._isHTML;
  }
}